import GestaoAVistaExportContext from '../../../../contexts/export/gestao-a-vista/GestaoAVistaExportContext';
import QCXPageTemplate from '../../../../templates/page/QCXPageTemplate';

export default function GestaoAVistaExportacaoPage({ children }) {
  return (
    <GestaoAVistaExportContext.Provider value={{}}>
      <QCXPageTemplate contextComponent={GestaoAVistaExportContext}>{children}</QCXPageTemplate>
    </GestaoAVistaExportContext.Provider>
  );
}
